(function () {
  "use strict";

  function WithdrawWalletBalanceController(
    $mdDialog,
    $mdToast,
    WalletService,
    AlertToastService
  ) {
    var $ctrl = this;

    $ctrl.walletBalance = 0;
    $ctrl.selectionMode = "all";
    $ctrl.customAmount = 0;

    $ctrl.$onInit = function () {
      loadWallet();
      // Default: if balance is less than request, prep the custom amount
      $ctrl.customAmount = Math.min($ctrl.walletBalance, $ctrl.withdrawAmount);
    };

    function loadWallet() {
      WalletService.getCustomerWalletByCustomerId($ctrl.customerId).query(
        function (data) {
          $ctrl.walletBalance = data.totalBalance || 0;
          // Re-calculate default in case data was empty initially
          $ctrl.customAmount = Math.min(
            $ctrl.walletBalance,
            $ctrl.withdrawAmount
          );
        }
      );
    }

    $ctrl.onModeChange = function () {
      if ($ctrl.selectionMode === "all") {
        $ctrl.customAmount = Math.min(
          $ctrl.walletBalance,
          $ctrl.withdrawAmount
        );
      }
    };

    $ctrl.getAppliedAmount = function () {
      if ($ctrl.selectionMode === "all")
        return Math.min($ctrl.walletBalance, $ctrl.withdrawAmount);
      return Math.min(
        $ctrl.customAmount,
        $ctrl.walletBalance,
        $ctrl.withdrawAmount
      );
    };

    $ctrl.getRemainingAmount = function () {
      return Math.max(0, $ctrl.withdrawAmount - $ctrl.getAppliedAmount());
    };

    $ctrl.cancel = function () {
      $mdDialog.cancel();
    };

    $ctrl.approveWithdraw = function () {
      var payload = {
        customerId: $ctrl.customerId,
        amount: $ctrl.getAppliedAmount(),
        amountUnit: "TOMAN"
      };

      if ($ctrl.orderBagId) payload["orderBagId"] = $ctrl.orderBagId;
      if ($ctrl.invoiceInfoId) payload["invoiceInfoId"] = $ctrl.invoiceInfoId;

      WalletService.payWalletForCusomerByAdmin().save(
        payload,
        onSuccess,
        onError
      );
    };

    function onSuccess(res) {
      $mdDialog.hide(res);
      $mdToast.show(
        $mdToast
          .simple()
          .textContent("پرداخت با موفقیت انجام شد")
          .position("top left")
      );
    }

    function onError(err) {
      var message = "خطا در پردازش کیف پول";
      if (err && err.data && err.data.result)
        message = "error.wallet." + err.data.result;
      AlertToastService.error(message, message, null);
    }

    $ctrl.getMaxAllowed = function () {
      return Math.min($ctrl.walletBalance, $ctrl.withdrawAmount);
    };
  }

  // Explicit dependency injection
  WithdrawWalletBalanceController.$inject = [
    "$mdDialog",
    "$mdToast",
    "WalletService",
    "AlertToastService"
  ];

  angular.module("tikonApp").component("pfWithdrawWalletBalance", {
    templateUrl: "app/components/partial-forms/wallet/withdraw-balance-wallet.html",
    controller: WithdrawWalletBalanceController,
    bindings: {
      customerId: "<",
      withdrawAmount: "<",
      orderBagId: "<?",
      invoiceInfoId: "<?"
    }
  });
})();
